import { render, staticRenderFns } from "./DevAsist.vue?vue&type=template&id=6f4cf59d"
import script from "./DevAsist.vue?vue&type=script&lang=js"
export * from "./DevAsist.vue?vue&type=script&lang=js"
import style0 from "./DevAsist.vue?vue&type=style&index=0&id=6f4cf59d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports